const oidcSession = {
  name: 'oidcSession',
  state: null,
  reducers: {
    onLoaded(state, session) {
      return { ...state, ...session };
    },
  },
};

export default oidcSession;
